import {remCalc} from '_themeUtils'

const commonColumnTitleStyles = {
    textStyle: 'paragraphSm',
    letterSpacing: remCalc(3),
    fontWeight: 500,
    textTransform: 'uppercase',
}

const searchSuggestions = {
    SearchSuggestions: {
        baseStyle: () => ({
            mainGrid: {
                display: {base: 'flex', lg: 'grid'},
                flexDir: 'column',
                templateColumns: {lg: '3fr 1px 2fr'},
                gap: 'spacing.10',
            },
            leftGrid: {
                templateColumns: {lg: 'repeat(3, 1fr)'},
                columnGap: 'spacing.4',
                rowGap: 'spacing.10',
            },
            columnTitle: {
                mb: 'spacing.6',
                ...commonColumnTitleStyles,
            },
            suggestionsColumnTitle: {
                mb: 'spacing.8',
                ...commonColumnTitleStyles,
            },
            columnContent: {
                gap: 'spacing.3',
            },
            gridDivider: {
                border: `${remCalc(1)} solid`,
                borderColor: 'color.border.header.default',
            },
        }),
    },
}

export default searchSuggestions
